import _ from 'lodash';
import React from 'react';
import AccountingIntegrationFilter from '~/components/filters/AccountingIntegrationFilter';
import CreditNoteSentFilter from '~/components/filters/CreditNoteSentFilter';
import CreditNoteStatusFilter from '~/components/filters/CreditNoteStatusFilter';
import { useIntegrations } from '~/contexts/IntegrationsContext';

export default function CreditNoteFiltersBar({ filters, onChange }) {
  const integrations = useIntegrations();
  return (
    <>
      {!_.isEmpty(filters.creditNoteStatuses) && (
        <CreditNoteStatusFilter
          value={filters.creditNoteStatuses}
          onChange={({ target: { value } }) => onChange({ creditNoteStatuses: value })}
        />
      )}

      {!_.isEmpty(filters.creditNoteSent) && (
        <CreditNoteSentFilter
          value={filters.creditNoteSent}
          onChange={({ target: { value } }) => onChange({ creditNoteSent: value })}
        />
      )}

      {integrations.accounting && !_.isEmpty(filters.creditNoteAccountingIntegrations) && (
        <AccountingIntegrationFilter
          value={filters.creditNoteAccountingIntegrations}
          onChange={({ target: { value } }) => onChange({ creditNoteAccountingIntegrations: value })}
        />
      )}
    </>
  );
}
